import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "54",
  height: "49",
  viewBox: "0 0 54 49"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"game_video_icon\" transform=\"translate(1.5 1.5)\"><g id=\"编组\" transform=\"translate(6.611 10.327)\"><path id=\"路径\" d=\"M0,7.169v6.505l11.753,7.188V0Z\" transform=\"translate(26.025 1.669)\" fill=\"#fff\" opacity=\"0.99\"></path><path id=\"形状\" d=\"M27.181,25.035H2.2A2.213,2.213,0,0,1,0,22.817V2.218A2.212,2.212,0,0,1,2.2,0h24.96a2.237,2.237,0,0,1,2.221,2.2V22.817A2.213,2.213,0,0,1,27.181,25.035ZM9.524,4.738V20.277L22.1,12.507,9.524,4.738Z\" fill=\"#fff\" opacity=\"0.99\"></path></g><rect id=\"矩形\" width=\"51\" height=\"46\" rx=\"7\" fill=\"none\" stroke=\"#fff\" stroke-miterlimit=\"10\" stroke-width=\"3\"></rect></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "54",
  height: "49",
  viewBox: "0 0 54 49"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<g id=\"game_videoC_icon\" transform=\"translate(1.5 1.5)\"><g id=\"编组\" transform=\"translate(6.611 10.327)\"><path id=\"路径\" d=\"M0,7.169v6.505l11.753,7.188V0Z\" transform=\"translate(26.025 1.669)\" fill=\"red\" opacity=\"0.99\"></path><path id=\"形状\" d=\"M27.18,25.034H2.2A2.212,2.212,0,0,1,0,22.817V2.218A2.212,2.212,0,0,1,2.2,0h24.96a2.236,2.236,0,0,1,2.22,2.2V22.817A2.212,2.212,0,0,1,27.18,25.034ZM9.525,4.738V20.277L22.1,12.507Z\" fill=\"red\" opacity=\"0.99\"></path></g><rect id=\"矩形\" width=\"51\" height=\"46\" rx=\"7\" fill=\"none\" stroke=\"red\" stroke-miterlimit=\"10\" stroke-width=\"3\"></rect><rect id=\"矩形-2\" data-name=\"矩形\" width=\"4\" height=\"51\" transform=\"translate(4.555 6.883) rotate(-45)\" fill=\"red\"></rect></g>", 1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOn)
    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
}